"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BlockRangeSeriesPointBottom_svg_1 = __importDefault(require("../../assets/images/BlockRangeSeriesPointBottom.svg"));

var BlockRangeSeriesPointTop_svg_1 = __importDefault(require("../../assets/images/BlockRangeSeriesPointTop.svg"));

exports.chartingAssets = {
  blockRangeChart: {
    seriesPointBottom: BlockRangeSeriesPointBottom_svg_1.default,
    seriesPointTop: BlockRangeSeriesPointTop_svg_1.default
  }
};